import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useGame } from '../contexts/GameContext';
import { LeoFace } from './LeoMascot';
import useSound from '../hooks/useSound';

export function CelebrationModal() {
  const { stars, showCelebration, setShowCelebration } = useGame();
  const { play } = useSound();

  React.useEffect(() => {
    if (showCelebration) play('celebrate');
  }, [showCelebration, play]);

  return (
    <AnimatePresence>
      {showCelebration && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40"
          onClick={() => setShowCelebration(false)}
          data-testid="celebration-modal"
        >
          {/* Confetti */}
          {Array.from({ length: 30 }).map((_, i) => (
            <motion.div
              key={i}
              initial={{ y: -100, x: Math.random() * window.innerWidth, rotate: 0, opacity: 1 }}
              animate={{ y: window.innerHeight + 100, rotate: 720, opacity: 0 }}
              transition={{ duration: 2 + Math.random() * 2, delay: Math.random() * 0.5 }}
              className="fixed w-3 h-3 rounded-sm"
              style={{
                left: 0,
                backgroundColor: ['#FFD700', '#FF7043', '#4FC3F7', '#66BB6A', '#AB47BC', '#26C6DA'][i % 6],
              }}
            />
          ))}

          <motion.div
            initial={{ scale: 0, rotate: -10 }}
            animate={{ scale: 1, rotate: 0 }}
            exit={{ scale: 0 }}
            transition={{ type: 'spring', damping: 12 }}
            className="bg-white rounded-3xl p-8 max-w-sm mx-4 text-center shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            <motion.div
              animate={{ y: [0, -20, 0], rotate: [0, 10, -10, 0] }}
              transition={{ duration: 0.8, repeat: 2 }}
            >
              <LeoFace mood="celebrating" size={80} className="mx-auto" />
            </motion.div>
            <h2 className="font-heading text-3xl text-brown mt-4">Amazing!</h2>
            <p className="font-body text-lg text-brown/70 mt-2">
              You've earned <span className="text-sunshine-dark font-bold">{stars}</span> stars! 🌟
            </p>
            <button
              onClick={() => setShowCelebration(false)}
              className="pill-btn bg-accent-coral text-white mt-6 text-base"
              data-testid="celebration-dismiss"
            >
              Keep going!
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function BadgeToast() {
  const { newBadge } = useGame();
  const { play } = useSound();

  React.useEffect(() => {
    if (newBadge) play('star');
  }, [newBadge, play]);

  return (
    <AnimatePresence>
      {newBadge && (
        <motion.div
          initial={{ x: 300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 300, opacity: 0 }}
          className="fixed bottom-20 lg:bottom-6 right-4 z-[90] bg-white rounded-2xl shadow-xl px-5 py-3 flex items-center gap-3 border-2 border-sunshine"
          data-testid="badge-toast"
        >
          <span className="text-3xl">{newBadge.icon}</span>
          <div>
            <p className="font-heading text-sm text-brown">New Badge Unlocked!</p>
            <p className="font-body text-xs text-brown/60">{newBadge.name}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
